// extracted by mini-css-extract-plugin
module.exports = {"Card":"ProjectCard_Card__AfzHV"};